import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "../config/routes";

interface SearchFormProps {
  id?: string;
  compact?: boolean;
  initialQuery?: string;
}

export function SearchForm({ id = "site-search", compact = false, initialQuery }: SearchFormProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const fromUrl =
    initialQuery !== undefined
      ? initialQuery
      : location.pathname === routes.search
        ? (params.get("q") ?? "")
        : "";
  const [query, setQuery] = useState(fromUrl);

  useEffect(() => {
    setQuery(fromUrl);
  }, [fromUrl]);

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    const value = query.trim();
    navigate(value ? `${routes.search}?q=${encodeURIComponent(value)}` : routes.search);
  }

  return (
    <form className={`search-form${compact ? " search-form-compact" : ""}`} role="search" onSubmit={onSubmit}>
      <label className="search-label" htmlFor={id}>
        Search
      </label>
      <div className="search-controls">
        <input
          id={id}
          type="search"
          name="q"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search the collection"
          autoComplete="off"
          enterKeyHint="search"
        />
        <button className="button" type="submit">
          Search
        </button>
      </div>
    </form>
  );
}
